import { useQueryClient } from '@tanstack/react-query';
import { apiBaseKeys, apiKeys } from 'core/api/api.routes';
import { usePocQuery } from 'core/custom-hooks/usePocQuery';
import { getSettings } from './api/api';

export const useSettings = () => {
  const queryClient = useQueryClient();

  const {
    data: settings,
    isLoading: isSettingsLoading,
    isLoadingError: isSettingsError,
  } = usePocQuery({
    queryKey: [apiBaseKeys.settings, apiKeys.settings.get()],
    queryFn: () => getSettings(),
  });

  const refreshSettings = () =>
    queryClient.invalidateQueries({
      queryKey: [apiBaseKeys.settings],
    });

  return {
    settings,
    isSettingsLoading,
    isSettingsError,
    refreshSettings,
  };
};
